export interface Theme {
  colors: {
    main: string;
    secondary: string;
    hoverMain: string;
    red: string;
    hoverRed: string;
    blue: string;
    hoverBlue: string;
    green: string;
    hoverGreen: string;
    purple: string;
  },
  fontsWeight: {
    regular: string;
    bold: string;
  },
  fontsSize: {
    main: string;
    secondary: string;
  }
}

export const patternTheme: Theme = {
  colors: {
    main: '#FF9E45',
    secondary: '#7A7A7A',
    hoverMain: '#FF8400',
    red: '#FF6745',
    hoverRed: '#CC4A2D',
    blue: '#459BFF',
    hoverBlue: '#3476C2',
    green: '#70BC78',
    hoverGreen: '#57965E',
    purple: '#A970FF'
  },
  fontsWeight: {
    regular: '#ffffff',
    bold: '#000000',
  },
  fontsSize: {
    main: '#ffffff',
    secondary: '#000000',
  },
};
